import React from 'react';

import { useTranslation } from 'react-i18next';
import { Button, Box, SegmentedControl } from '@utex/ui-kit';
import { buttonPadding } from './styles';

interface LoginBlockProps {
  onLogin: () => void;
  onRegistration: () => void;
}

export function LoginBlock(props: LoginBlockProps) {
  const { onLogin, onRegistration, ...other } = props;
  const { t } = useTranslation('sideMenu');

  return (
    <Box display="flex" margin={[0, 45, 11, 23]} {...other}>
      <SegmentedControl>
        <Button
          view="primary-dim"
          css={buttonPadding}
          data-testid="signup-btn"
          onClick={() => {
            onRegistration();
          }}
          data-gtm="sidemenu-signup-btn"
        >
          {t('Sign Up')}
        </Button>

        <Button data-testid="signin-btn" data-gtm="sidemenu-signin-btn" css={buttonPadding} view="extra-dim" onClick={onLogin}>
          {t('Log In')}
        </Button>
      </SegmentedControl>
    </Box>
  );
}
